import React from 'react'

import { cn } from '@/lib/utils'

/** Ritmo vertical de pantallas interiores; el ancho lo fija PlatformShell (INTERIOR_PAGE_CONTAINER). */
export function InteriorPageLayout({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cn('space-y-6', className)}>{children}</div>
}
